import { CheckCircle2, KeyRound, Loader2 } from "lucide-react";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, apiError } from "../../lib/api";
import { PLATFORM, usePlatformTheme } from "../../lib/platformBrand";

const Pw = ({ label, value, onChange, testid }) => (
  <label className="field"><span className="field-label">{label}</span>
    <input type="password" required autoComplete="new-password" className="field-input" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
  </label>
);

export default function ResetPassword() {
  usePlatformTheme();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [f, setF] = useState({ next: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.next !== f.confirm) {
      setErr("The new passwords don't match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: f.next });
      setDone(true);
    } catch (e2) {
      setErr(apiError(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="grid min-h-screen place-items-center bg-linen px-4 font-sans text-ink" data-testid="reset-password-page">
      <div className="w-full max-w-sm rounded-3xl border border-ink/10 bg-white p-8 shadow-xl">
        <img src={PLATFORM.logo} alt={PLATFORM.name} className="mx-auto h-16 w-auto" />
        {done ? (
          <div className="mt-6 text-center" data-testid="reset-success">
            <CheckCircle2 className="mx-auto h-10 w-10 text-gold" />
            <h1 className="mt-3 font-serif text-2xl font-bold text-brand">Password updated</h1>
            <Link to="/admin/login" className="btn-primary mt-6 w-full" data-testid="reset-signin-link">Sign in</Link>
          </div>
        ) : !token ? (
          <p className="mt-6 text-center text-sm text-red-600" data-testid="reset-missing-token">This reset link is incomplete. Request a new one from the sign-in page.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <h1 className="text-center font-serif text-2xl font-bold text-brand">Choose a new password</h1>
            <Pw label="New password" value={f.next} onChange={(next) => setF({ ...f, next })} testid="reset-new" />
            <Pw label="Confirm new password" value={f.confirm} onChange={(confirm) => setF({ ...f, confirm })} testid="reset-confirm" />
            <p className="text-xs text-ink/50">At least 10 characters, with letters and numbers.</p>
            {err && <p className="text-sm text-red-600" data-testid="reset-error">{err}</p>}
            <button className="btn-primary w-full" disabled={busy} data-testid="reset-submit">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />}Save new password
            </button>
          </form>
        )}
        <p className="mt-6 text-center text-xs"><Link to="/admin/login" className="text-gold underline" data-testid="reset-back-link">Back to sign in</Link></p>
      </div>
    </div>
  );
}
